module.exports = __webpack_public_path__ + "img/img-3.1cfde94e.jpg";